<template>
  <div class="h-screen pt-6 flex flex-col bg-white">
    <Container class="w-full flex list-none p-0 m-0 pb-3 bg-surface-0 dark:bg-surface-800 border-b border-surface-200 dark:border-surface-700 text-surface-900 dark:text-surface-0/80">
      <PageHeading :title="$t('pages.admin.device_import.device_import_index.device_imports')"/>
    </Container>
    <ListDetailLayout
        :store="deviceImportsStore"
        index-route-name="admin.devices.import"
        create-permissions="create:imports"
        @on-paginate="(page) => useOnPaginate(page, refreshDeviceImports, params)"
        @on-search="(page) => useOnSearch(page, refreshDeviceImports, params)"
        @on-refresh="refreshDeviceImports()"
        @on-show="showDeviceImportDetails"
    >

      <template #list>
        <li v-for="deviceImport in deviceImportsStore.getDeviceImports" :key="deviceImport.id" @click="showDeviceImportDetails(deviceImport)">
          <div :class="['border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">
            <div class="min-w-0 flex flex-row w-full items-start justify-between">
              <div class="flex-1">
                <div class="flex items-start gap-x-3">
                  <p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">
                    {{ deviceImport.name }}</p>
                </div>
                <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
                  <p class="whitespace-nowrap">
                    {{ deviceImport.user?.name || '-' }}
                  </p>
                </div>
                <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
                  <p class="whitespace-nowrap">
                    {{ $dateService(deviceImport.request_date).format('MMM DD, YYYY HH:mm:ss') }}
                  </p>
                </div>
              </div>
              <div class="flex flex-col items-end space-y-1">
                <div class="text-sm text-surface-600 dark:text-surface-500">{{ useFilesize(deviceImport.size_bytes) ?? ""}}</div>
                <FlatBadge :color="statuses[deviceImport.status]" :value="deviceImport.status"/>
              </div>
            </div>
          </div>
        </li>
      </template>

      <template #detail>
        <div v-if="deviceImportForm">
          <DeviceImportForm
              :form="deviceImportForm"
              :disabled="!$auth.hasPermission('create:imports', true)"
              @on-save="refresh"
          />
        </div>
      </template>

    </ListDetailLayout>
    <DeviceImportSlideOver ref="slideOver"/>
  </div>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useDeviceImportsStore } from "@/stores/deviceImports.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";
import DeviceImportForm from "@/Forms/Device/Import/DeviceImportForm.vue";
import DevicePropertiesForm from "@/Forms/Device/DevicePropertiesForm.vue";
import DeviceDownloadLogSlideOver from "@/Slideovers/DeviceDownloadLogSlideOver.vue";
import DevicesBeingUpdatedListItem from "@/Widgets/Lists/DevicesBeingUpdatedListItem.vue";
import DeviceImportSlideOver from "@/Slideovers/DeviceImportSlideOver.vue";
import FlatBadge from "@/Components/Badges/FlatBadge.vue";
import {IconAlertTriangleFilled} from "@tabler/icons-vue";
import {useFilesize} from "../../../../Composables/Filesize.js";
import PageHeading from "@/Components/PageHeading.vue";

export default {
	name: "DevicesIndex",
  components: {
    PageHeading,
    IconAlertTriangleFilled,
    FlatBadge,
    DeviceImportSlideOver,
    DevicesBeingUpdatedListItem,
    DeviceDownloadLogSlideOver, DevicePropertiesForm, Container, ListDetailLayout, DeviceImportForm},
  data() {
		return {
			params: {
        include: [
            'user',
            'importType',
        ],
        fields: {
          imports: [
            'id',
            'import_type_id',
            'name',
            'size_bytes',
            'request_date',
            'user_id',
            'status',
          ]
        },
      },
      deviceImportForm: undefined,
      statuses: {
        PENDING: 'gray',
        IN_PROGRESS: 'yellow',
        COMPLETE: 'green',
        FAILED: 'red',
      },
		}
	},
  emits: [
    'on-save',
  ],
	methods: {
    useFilesize,
		useOnSearch,
		useOnPaginate,
		refreshDeviceImports(){
			return this.deviceImportsStore.indexDeviceImports(this.params);
		},
    showDeviceImportDetails(deviceImport) {
      this.$refs.slideOver.showDeviceImportDetails(deviceImport);
    },
    async getBlankImport() {
      this.deviceImportForm = undefined;
      this.deviceImportForm = await this.deviceImportsStore.createDeviceImport()
    },
    async refresh() {
      this.refreshDeviceImports()
      await this.getBlankImport();
    }
	},
	computed: {
		...mapStores(useDeviceImportsStore)
	},
	async mounted() {
    await this.getBlankImport();
    await this.refreshDeviceImports()
	}
}
</script>